import PropTypes from 'prop-types';
import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { withTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import BaseListContainer from '../baseContainers/BaseListContainer';
import { MenuButtonComponent } from '../components/MenuButtonComponent';
import CriteriaCalendarRangeComponent from '../components/criteria/CriteriaCalendarRangeComponent';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import CardOrderService from '../services/CardOrderService';
import CardOrderTemplateDialog from './CardOrderTemplateDialog';

class CardOrderListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new CardOrderService());
        this.state = {
            orderId: props.orderId,
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            cardKindOpt: [
                {enumValue: 'FIRM', label: props.t(`EcCardKind.FIRM`)},
                {enumValue: 'VEHICLE', label: props.t(`EcCardKind.VEHICLE`)},
                {enumValue: 'VEHICLE_PERSON', label: props.t(`EcCardKind.VEHICLE_PERSON`)},
                {enumValue: 'PERSON', label: props.t(`EcCardKind.PERSON`)},
            ],
            filters: {},
            saveAsTemplate: false,
        };
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.actionTemplate = this.actionTemplate.bind(this);
        this.orderAmountTemplate = this.orderAmountTemplate.bind(this);
        this.handleSaveAsTemplate = this.handleSaveAsTemplate.bind(this);
        this.packageNumberListTemplate = this.packageNumberListTemplate.bind(this);
    }

    getDataKey() {
        return 'id';
    }

    getListTitle() {
        return 'order-card.orderList';
    }

    updateSearchCriteria(criteria) {
        return {
            dateFrom: criteria.dateFrom,
            dateTo: criteria.dateTo,
            text: criteria.text,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            dateFrom: undefined,
            dateTo: undefined,
            text: '',
            firstResult: 0,
            maxResults: 10,
            sortField: 'orderDate',
            sortAsc: false,
        };
    }

    extractOrderIdFromSearch(history, paramName) {
        if (!!history && !!history.location && !!history.location.search) {
            const search = new URLSearchParams(history.location.search);
            return search.get(paramName);
        }
        return undefined;
    }

    initializeFromBackend() {
        const orderId = this.extractOrderIdFromSearch(this.props.history, 'id');
        const draftOrderId = this.extractOrderIdFromSearch(this.props.history, 'draftId');
        if (!!orderId) {
            this.setState({orderId});
            this.handleOpenDialog(undefined, {id: orderId});
        } else if (!!draftOrderId) {
            this.setState({orderId: draftOrderId});
            this.handleOpenDialog(undefined, {id: draftOrderId});
        }
    }

    getCriteriaName() {
        return 'order-list-sc';
    }

    getContainerListName() {
        return 'order-list-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    updateListElements(list) {
        return list && list.length
            ? list.map((item) => {
                  item.orderDate = new Date(item.orderDate);
                  return item;
              })
            : [];
    }

    renderCriteria() {
        const {t} = this.props;
        return (
            <div className='row'>
                <CriteriaCalendarRangeComponent
                    id='orderDate-sc'
                    idFrom='dateFrom-sc'
                    idTo='dateTo-sc'
                    name='orderDate'
                    nameFrom='dateFrom'
                    nameTo='dateTo'
                    label={t('order-card.orderDate')}
                    colClass='col-xl-6 col-lg-6 col-md-12 col-sm-12'
                    from={this.state.criteria.dateFrom}
                    to={this.state.criteria.dateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    showButtonBar
                    sharedLabel
                    renderDash
                    placeholderFrom={t('cards.from')}
                    placeholderTo={t('cards.to')}
                    inputsClassName='col-6'
                />
                <CriteriaDropdownComponent
                    id='cardKind-sc'
                    name='cardKind'
                    showClear
                    label={t('order-card.cardType')}
                    colClass='col-xl-3 col-lg-3 col-md-6 col-sm-12'
                    value={this.state.criteria.cardKind}
                    options={this.state.cardKindOpt}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    //optionValue='enumValue'
                    dataKey='enumValue'
                    // refreshFromBackend
                />
            </div>
        );
    }

    createHeaderWithIcon(text, imgName) {
        return (
                <span className="p-column-title"> <img className='card-icon' alt={this.translate('list.filter')} src={`/images/` + imgName + `.svg`} />&nbsp; {text} </span>

        );
    }
    packageNumberListTemplate(field,  rowData) {
        if(rowData !== undefined && rowData.packageNumber !== null){
            return(
                rowData.packageNumber?.map(pn => 
                    { 
                        return (
                      <span> {pn} <br/></span>
                 )}
             )
            )
        }
        else return "Test";
       
        
    }

    prepareColumns() {
        const {t} = this.props;
        return  this.authService.getProfile().agreementType === 'CASH' ? [
            {
                key: 'orderDate',
                field: 'orderDate',
                header: t('order-card.orderDate'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'orderDate', 'DD-MM-YYYY'),
            },
            {
                key: 'cardKind',
                field: 'cardKind',
                header: t('order-card.cardType'),
                sortable: true,
                body: this.enumTemplate.bind(this, 'EcCardKind', 'cardKind'),
            },
            {
                header: this.createHeaderWithIcon(t('order-card.virtualCount'), 'ico_virtual_card_type'),
                sortable: true,
                field: 'totalCount',
            },
            {
                field: 'nonMultiEnergeticCount',
                header: this.createHeaderWithIcon(t('order-card.plasticCount'), 'ico_plastic_card_type'),
                sortable: true,
            },
            {
                key: 'packageNumber',
                field: 'packageNumber',
                header: t('order-card.packageNumbers'),
                sortable: false,
                body: this.packageNumberListTemplate.bind(this, 'packageNumber'),
            },

            {
                key: 'actions',
                header: '',
                body: this.actionTemplate.bind(this),
                className: 'table-column-action',
            }
        ] :
        [
            {
                key: 'orderDate',
                field: 'orderDate',
                header: t('order-card.orderDate'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'orderDate', 'DD-MM-YYYY'),
            },
            {
                key: 'cardKind',
                field: 'cardKind',
                header: t('order-card.cardType'),
                sortable: true,
                body: this.enumTemplate.bind(this, 'EcCardKind', 'cardKind'),
            },
            {
                header: this.createHeaderWithIcon(t('order-card.virtualCount'), 'ico_virtual_card_type'),
                sortable: true,
                field: 'totalCount',
            },
            {
                field: 'nonMultiEnergeticCount',
                header: this.createHeaderWithIcon(t('order-card.plasticCount'), 'ico_plastic_card_type'),
                sortable: true,
            },
          {
            field: 'multiEnergeticCount',
            header: this.createHeaderWithIcon(t('order-card.multienergeticCount'), 'ico_multienergetic_plastic_card_type'),
            sortable: true,

        }, 
        {
            key: 'packageNumber',
                field: 'packageNumber',
                header: t('order-card.packageNumbers'),
                sortable: false,
                body: this.packageNumberListTemplate.bind(this, 'packageNumber'),
        },
        
        {
            key: 'actions',
            header: '',
            body: this.actionTemplate.bind(this),
            className: 'table-column-action',
        }
        ];
    }

    orderAmountTemplate(field, rowData) {
        const {t} = this.props;
        return (
            <span className='invoice-amount-container'>
                <span className='invoice-amount'>
                    {/* {t('transaction.amountGross')} */}
                    <NumberFormat
                        value={field ? rowData[field] : rowData}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
            </span>
        );
    }

    actionTemplate(rowData) {
        const {t} = this.props;
        return (
            <MenuButtonComponent
                iconSvg='ico_more_3_dots'
                items={
                    this.props.draft
                        ? [
                              {
                                  label: t('details.edition'),
                                  icon: 'pi',
                                  command: (e) => this.handleOpenDialog(e, rowData),
                              },
                              {
                                  label: t('order-card.placeOrder'),
                                  icon: 'pi',
                                  command: (e) => (window.location.href = `${this.props.orderAgainUrl}/${rowData.id}`),
                              },
                              {
                                  label: t('order-card.saveAsDraft'),
                                  icon: 'pi',
                                  command: (e) => this.handleOpenDialog(e, rowData, true),
                              },
                          ]
                        : [
                              {
                                  label: t('list.details'),
                                  icon: 'pi',
                                  command: (e) => this.handleOpenDialog(e, rowData),
                              },
                              {
                                  label: t('order-card.placeOrder'),
                                  icon: 'pi',
                                  command: (e) => (window.location.href = `${this.props.orderAgainUrl}/${rowData.id}`),
                              },
                              {
                                  label: t('order-card.saveAsDraft'),
                                  icon: 'pi',
                                  command: (e) => this.handleOpenDialog(e, rowData, true),
                              },
                          ]
                }
            />
        );
    }

    handleSaveAsTemplate(e, rowData) {
        const {t} = this.props;
        this.blockUi();
        this.service
            .addTemplate(rowData)
            .then((response) => {
                this.unblockUi();
                this.showSuccessMessage(t('order-card.successSaveAsTemplate'));
            })
            .catch((err) => {
                this.unblockUi();
                this.showErrorMessage(t('error.saveAsTemplateError'));
            });
    }

    prepareHeaderItems() {
        return this.isUserInRole('ROLE_FLEET') ? [{type: 'LABEL', className: 'float-left'}] : [];
    }

    handleOpenRow(rowData, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ids: [rowData.id], element: rowData});
    }

    handleOpenDialog(e, rowData, saveAsTemplate = false) {
        const {t} = this.props;
        this.blockUi(() => {
            this.service
                .get(rowData.id)
                .then((element) => {
                    this.setState({element, saveAsTemplate}, () => this.unblockUi());
                })
                .catch((err) => {
                    this.unblockUi();
                    this.showErrorMessage(t('order-card.errorGetDetails'));
                });
        });
    }

    handleCloseDialog(e, callBack) {
        this.setState({element: undefined}, () => {
            if (callBack) {
                callBack();
            }
        });
    }

    render() {
        const {t} = this.props;
        return (
            <div className='container-fluid order-list-container'>
                {this.state.element !== undefined ? (
                    <CardOrderTemplateDialog
                        key={'card-order-template-dialog'}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        showMessage={this.showMessage}
                        element={this.state.element}
                        onHide={(e) =>
                            this.handleCloseDialog(e, () => {
                                if (!!this.state.orderId) {
                                    this.setState({orderId: undefined}, () => this.props.history.replace('/card-order-list', {}));
                                } else if (this.state.saveAsTemplate) {
                                    this.setState({saveAsTemplate: false});
                                }
                            })
                        }
                        visible={!!this.state.element}
                        viewMode={this.props.draft || this.state.saveAsTemplate ? 'EDIT' : 'VIEW'}
                        afterSave={(e) =>
                            this.handleCloseDialog(e, () => {
                                if (this.state.saveAsTemplate) {
                                    this.setState({saveAsTemplate: false}, () => {
                                        if (this.props.refreshList) {
                                            this.props.refreshList();
                                        } else {
                                            this.unblockUi();
                                        }
                                    });
                                } else if (this.props.draft) {
                                    this.refreshTable();
                                    this.unblockUi();
                                } else if (!!this.state.orderId) {
                                    this.setState({orderId: undefined}, () => this.props.history.replace('/card-order-list', {}));
                                }
                            })
                        }
                        containerListName={this.getContainerListName()}
                        _isMounted={this._isMounted}
                        className='card-order-template-dialog'
                        draft={this.props.draft}
                        template={this.state.saveAsTemplate}
                        newTemplate={this.state.saveAsTemplate}
                        embedded
                    />
                ) : null}
                <BreadcrumbsItem to='/card-list'>{t('cards.listName')}</BreadcrumbsItem>
                {this.renderAddToTrustedDevicesDialog()}
                {this.renderView()}
            </div>
        );
    }
}

CardOrderListContainer.defaultProps = {
    lazy: false,
    draft: false,
    disableSelection: false,
    selectionMode: 'multiple',
    cardTypePanels: false,
    detailUrl: '#/card-details',
    inProgress: false,
    orderAgainUrl: '#/order-card-again',
};

CardOrderListContainer.propTypes = {
    phoneNumber: PropTypes.string,
    cardTypePanels: PropTypes.bool,
    draft: PropTypes.bool,
    disableSelection: PropTypes.bool,
    handleGoToDetail: PropTypes.func,
};

export default withTranslation()(CardOrderListContainer);
